import { useToggle } from 'ahooks';
import { Divider, Flex, Button, pxArrayToRem } from '@archipro-design/aria';
import { Filter } from '@archipro-design/icons';

import FilterDrawer, {
    applyCount,
} from '@modules/search/components/filter-drawer/FilterDrawer';
import FilterBarFilters from '@modules/search/components/search-filter-section/FilterBarFilters';
import AppliedFilters from '@modules/search/components/search-filter-section/AppliedFilters';
import { resetFilterStates } from '@modules/search/util/reset-filter-states';
import SearchSort from '@modules/search/components/search-filter-section/SearchSort';
import { useSearchSortOptions } from '~/modules/search/hook/use-search-sort-options';
import type { CategoryFilterSectionProps } from './CategoryFilterSection';

export const CategoryFilterSection = ({
    category,
    searchFilters,
}: CategoryFilterSectionProps) => {
    const [
        filterDrawerOpen,
        { toggle: toggleFilterDrawer, set: setFilterDrawerState },
    ] = useToggle(false);
    const {
        filters,
        filterStates,
        appliedFilters,
        filterBarFilters,
        updateFilter,
        resetFilters,
    } = searchFilters;

    const optionResult = useSearchSortOptions({
        category,
        sortBy: filterStates.sortBy,
        defaultSortBy: filterStates.defaultSortBy,
    });

    return (
        <div className="px-12.5 pb-6">
            <Divider
                size={2}
                design={{ padding: pxArrayToRem([0, 0, 25, 0]) }}
            />
            <Flex column gap="space-24">
                <Flex vAlign="center" gap="space-36">
                    <Button
                        transparent
                        size={30}
                        variables={{ buttonPadding: 0, iconPadding: 0 }}
                        iconBefore={<Filter />}
                        onClick={toggleFilterDrawer}
                    >
                        {applyCount(
                            'Show Filters',
                            appliedFilters?.length ?? 0,
                        )}
                    </Button>

                    {filterBarFilters && filterBarFilters.length > 0 && (
                        <FilterBarFilters
                            filters={filterBarFilters}
                            updateFilter={updateFilter}
                        />
                    )}
                    {optionResult.items.length > 0 && (
                        <SearchSort optionResult={optionResult} />
                    )}
                </Flex>
                {appliedFilters && appliedFilters.length > 0 && (
                    <AppliedFilters
                        filterItems={appliedFilters}
                        resetFilters={() =>
                            resetFilters(
                                resetFilterStates(filterStates, [
                                    ...(searchFilters.ignoreFilterKeys ?? []),
                                    'category',
                                ]),
                            )
                        }
                    />
                )}
            </Flex>

            <FilterDrawer
                open={filterDrawerOpen}
                onOpenChange={(_, data) => setFilterDrawerState(!!data)}
                filterSections={filters}
                filterStates={filterStates}
                category={category}
                onApplyFilters={(_, data) => {
                    setFilterDrawerState(false);
                    resetFilters(data);
                }}
                ignoreFilterKeys={searchFilters.ignoreFilterKeys}
            />
        </div>
    );
};
